import { useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import Logo from "../images/Logo.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleNavigateAndScroll = (id) => {
    setMenuOpen(false);
    if (!isHome) {
      navigate("/", { replace: false });
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const offset = el.offsetTop - 70;
          window.scrollTo({ top: offset, behavior: "smooth" });
        }
      }, 100);
    } else {
      const el = document.getElementById(id);
      if (el) {
        const offset = el.offsetTop - 70;
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
    }
  };

  const menuItems = [
    { id: "homeSection", label: "HOME" },
    { id: "aboutSection", label: "ABOUT US" },
    { id: "collectionSection", label: "COLLECTION" },
    { id: "contactSection", label: "CONTACT US" },
  ];

  return (
    <header className="fixed top-0 left-0 w-full z-50 font-bold text-[#f4a420]">
      <div
        className={`
          px-3 py-4 2xl:px-6 5xl:px-10 8xl:px-14 9xl:px-20 11xl:px-24
          8xl:py-8 10xl:py-14 11xl:py-20
          bg-[linear-gradient(357deg,rgba(0,0,0,0)_2.18%,#000_97.35%)] 
          2xl:bg-[#84186a]
          2xl:bg-none 2xl:animate-none
        `}
      >
        <div className="flex items-center justify-between h-16 relative">
          {/* Hamburger Menu (Mobile) */}
          <button className="block 2xl:hidden text-2xl z-20" onClick={toggleMenu}>
            ☰
          </button>

          {/* Logo */}
          <div className="absolute left-1/2 transform -translate-x-1/2 2xl:static 2xl:transform-none 2xl:left-0">
            {isHome ? (
              <ScrollLink
                to="homeSection"
                smooth={true}
                duration={200}
                offset={-70}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer"
              >
                <img src={Logo} alt="Logo" className="w-[100px] 8xl:w-[130px]" />
              </ScrollLink>
            ) : (
              <Link to="/" onClick={() => setMenuOpen(false)}>
                <img src={Logo} alt="Logo" className="w-[100px]" />
              </Link>
            )}
          </div>

          {/* Desktop Navigation */}
          <div className="hidden 2xl:flex flex-grow justify-center gap-14">
            {menuItems.map((item) =>
              isHome ? (
                <ScrollLink
                  key={item.id}
                  to={item.id}
                  smooth={true}
                  duration={200}
                  offset={-70}
                  className="cursor-pointer"
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </ScrollLink>
              ) : (
                <span
                  key={item.id}
                  onClick={() => handleNavigateAndScroll(item.id)}
                  className="cursor-pointer"
                >
                  {item.label}
                </span>
              )
            )}
          </div>

          {/* Spacer (Mobile) */}
          <div className="w-6 block 2xl:hidden"></div>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`absolute  left-0  ${
            menuOpen ? "translate-x-0 w-full " : "-translate-x-full "
          } bg-[#fff] z-20 2xl:hidden`}
        >
          <nav className="flex flex-col px-7 py-10 gap-4">
             {/* Close button */}
  <button
    onClick={() => setMenuOpen(false)}
    className=" flex justify-left px-6  text-3xl text-[#f4a420] font-bold"
  >
    &times;
  </button>
            {menuItems.map((item) =>
              isHome ? (
                <ScrollLink
                  key={item.id}
                  to={item.id}
                  smooth={true}
                  duration={200}
                  offset={-70}
                  onClick={() => setMenuOpen(false)}
                  className="py-2 px-6 text-[#f4a420]"
                >
                  {item.label}
                </ScrollLink>
              ) : (
                <span
                  key={item.id}
                  onClick={() => handleNavigateAndScroll(item.id)}
                  className="py-2 px-6 text-[#f4a420] cursor-pointer"
                >
                  {item.label}
                </span>
              )
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
